/**
 * useBusiness Hook
 * Manages business data fetching and operations
 */

import { useState, useCallback } from 'react';
import { fetchBusinessById } from '../domain/useCases/Business/fetchBusinessById.js';
import { registerBusiness } from '../domain/useCases/Business/registerBusiness.js';
import { editBusiness } from '../domain/useCases/Business/editBusiness.js';
import { fetchQRPlateData } from '../domain/useCases/Business/fetchQRPlateData.js';
import { fetchUserBusinesses } from '../domain/useCases/Business/fetchUserBusinesses.js';

export const useBusiness = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getBusinessById = useCallback(async (businessId) => {
    setLoading(true);
    setError(null);
    try {
      return await fetchBusinessById(businessId);
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const createBusiness = useCallback(async (businessData) => {
    setLoading(true);
    setError(null);
    try {
      return await registerBusiness(businessData);
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const updateBusiness = useCallback(async (businessId, businessData) => {
    setLoading(true);
    setError(null);
    try {
      return await editBusiness(businessId, businessData);
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getQRPlateData = useCallback(async (businessId) => {
    setLoading(true);
    setError(null);
    try {
      return await fetchQRPlateData(businessId);
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getUserBusinesses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      return await fetchUserBusinesses();
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getBusinessById,
    createBusiness,
    updateBusiness,
    getQRPlateData,
    getUserBusinesses,
  };
};

